module.exports = __webpack_public_path__ + "static/media/download.22de4362.svg";